export default "Décret Tertiaire — Trajectoire OPERAT immeubles bureaux | Solution Éco France";
